module.controller('atmAccessCtrl', ['$scope', '$state', '$http', '$q', 'cacheService', 'Session', 'Transform', 'baseURI', 'OVERLAY', 'accountService',
  function($scope, $state, $http, $q, cacheService, Session, Transform, baseURI, OVERLAY, accountService) {

    var atmUrl = baseURI + 'card/cash/access';
    $scope.card = accountService.getAccount($state.params.username);
    $scope.atmToggle = $scope.card.atmAccess ? 'on' : 'off';

    $scope.overlay = OVERLAY['member.home.profile/atm'];
    $scope.formData = {};
    $scope.alert = {};
    $scope.alert.alertMessage = 'Sorry, we were unable to update your cards at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';

    $scope.updated = function(value){
      $scope.atmToggle = value;
    };

    $scope.processForm = function(formData){
      var postData = { Username: $scope.card.username, ATMAccess: $scope.atmToggle === 'on' };

      $http({
        method: 'PUT',
        url: atmUrl,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: Transform.encode(postData)
      }).then(function(resp){
        var data = resp.data;

        cacheService.clear('atm', $scope.card.username);
        $scope.card.atmAccess = $scope.atmToggle === 'on';
        accountService.updateAccounts([$scope.card]);
        $scope.loading = false;
        $scope.alert.successMessage = 'You have updated your card!';
        $scope.alert.successShown = true;
        $state.go('member.home.profile/atm.step2');
      }).catch(function(error){
        $scope.alert.alertShown = true;
        $scope.loading = false;
      });
    };
  }
]);
